<template>
	<div class="date-select-view edit" @click.stop="toggle($event)" :value="value" @input="$emit('input')">
		<div v-if="label !== false" class="edit__label">{{ label }} <span v-if="!optional">*</span></div>
		<input type="text" :value="_value" readonly>
	</div>
</template>

<script>
	import DatePopupView from './DatePopupView'

	export default {
		props: {
			value: {
				type: String
			},
			controller: {
				
			},
			label: {
				type: String
			},
			optional: {
				type: Boolean
			},
			suggestions: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		computed: {
			_value() {
				
				return this.$options.filters.date(this.value);
			}
		},
		watch: {
			value() {
				if (this.controller.getPopupView()) this.controller.getPopupView().value = this.value;
				this.controller.close();
			}
		},
		methods: {
			input(value) {
				this.$emit('input', value);
			},
			toggle(event) {
				console.log('toggle');

				this.controller.toggle(DatePopupView, {
					anchor: event.currentTarget,
					value: this.value,
					owner: this,
					suggestions: this.suggestions
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.date-select-view {
		& > input {
			cursor: pointer;
		}

		&.light {
			& > input {
				background-color: white;
				color: black;
			}
		}

		&.gray {
			& > input {
				background-color: rgb(231, 231, 231);
				color: black;
			}
		}
	}
</style>